import { useQuery } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'
import { authKeys } from '../api/auth.keys'
import { GetUIConfigResponse } from '../types'

/**
 * Hook to fetch UI config
 */
export function useUIConfig() {
  return useQuery<GetUIConfigResponse, Error>({
    queryKey: authKeys.uiConfig(),
    queryFn: authApi.getUIConfig,
    staleTime: 10 * 60 * 1000, // 10 minutes
  })
}